var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-body-box"},[_c('div',{staticClass:"table",staticStyle:{"display":"block"}},[_c('Table',{ref:"selection",attrs:{"columns":_vm.reasonDataColumns,"data":_vm.reasons},scopedSlots:_vm._u([{key:"序号",fn:function(ref){
var index = ref.index;
return [_vm._v(" "+_vm._s(index+1)+" ")]}},{key:"操作",fn:function(ref){
var row = ref.row;
return [_c('a',{staticClass:"solution-a",attrs:{"href":"javascript:"},on:{"click":function($event){return _vm.onEditReason('look',row)}}},[_vm._v("处理方法（"+_vm._s(row.solutionList.length)+"）")])]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }